<div class="flexed-header" 
    [ngClass]="{ 'login-header' : !environmentVariables?.ENABLE_LOGIN_TEXT_AS_ICON && (!userData || userData?.is_guest) && !environmentVariables?.ENABLE_MENU_BUTTON }">
    <ng-container *ngIf="!userData || userData?.is_guest">
        <div (click)="logIn()" class="pointer d-inline-flex" id="signIn">
            <span *ngIf="!environmentVariables?.ENABLE_LOGIN_TEXT_AS_ICON"
                class="font-size-initial"
                [ngStyle]="{ color: headerTextColor }"
                [ngClass]="{
                    'd-none-mob': environmentVariables?.ENABLE_MENU_BUTTON
                }"
            >
                {{ "header.logIn" | translate }}
                <ng-container *ngIf="environmentVariables?.ENABLE_SIGN_UP">
                    / {{ "header.signUp" | translate }}
                </ng-container>
            </span>

        

          <ng-container  *ngIf="environmentVariables?.ENABLE_LOGIN_TEXT_AS_ICON">
            <button
            class="header-icon "
            mat-mini-fab
            matBadgePosition="after"
            [ngClass]="{
              'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  
              'icons-background' :
              ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
          }"
          >
            <mat-icon 

            id="favIcon" class="material-icons notranslate  defulat-icons-color " 
            [ngClass]="{
              'material-symbols-outlined':(changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
              'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
          }">
                login
            </mat-icon>
        
          </button>

          </ng-container>
 

        </div>


   
    
    </ng-container>

    <ng-container *ngIf="userData && !userData?.is_guest">
        <mat-menu #loginUser="matMenu" [hasBackdrop]="false" class="mat-menu">
            <div
                (mouseenter)="this.enteredMenu = true"
                (mouseleave)="closeMatMenu()"
            >
                <button
                    [routerLink]="['/' + lang + '/account/profile']"
                    mat-menu-item
                >
                    <mat-icon
                    (mouseover)="changeIconFill=false"
                    (mouseleave)="changeIconFill=true" 
                        class="material-icons mr-1 position-icon-1"
                        aria-hidden="false"
                        [ngClass]="{
                          'material-symbols-outlined': (changeIconFill && !environmentVariables?.ENABLE_HEADER_ICONS_FILL) 
                      }"
                    >
                       person
                        </mat-icon
                    >
                    <span class="menu-icons">
                        {{ userData?.name }}
                        {{ "header.dropdown.profile" | translate }}
                    </span>
                </button>
                <button
                    [routerLink]="['/' + lang + '/account/order-history']"
                    mat-menu-item
                >
                    <mat-icon class="material-icons mr-1 position-icon-1"
                        >history</mat-icon
                    ><span class="menu-icons">
                        {{ "header.dropdown.orderHistory" | translate }}</span
                    >
                </button>

                <div
                    (click)="favorite()"
                    class="favoite-container mat-menu-item show-menu-icons-in-drop-down hide-menu-icons-in-drop-down"
                    *ngIf="environmentVariables?.ENABLE_MULTI_INVENTORY"
                >
                    <embryo-WishList></embryo-WishList>
                    <span class="icon-text">{{
                        "button.favorite" | translate
                    }}</span>
                </div>
                <div
                    class="wallet-container mat-menu-item show-menu-icons-in-drop-down hide-menu-icons-in-drop-down"
                    *ngIf="environmentVariables?.ENABLE_MULTI_INVENTORY"
                >
                    <app-compare-list-menu
                        *ngIf="!environmentVariables?.DISABLE_COMPARE"
                        [lang]="lang"
                    ></app-compare-list-menu>
                    <span class="icon-text">{{
                        "compare.compare" | translate
                    }}</span>
                </div>
                <div 
                  *ngIf="
                            environmentVariables?.LOYALTY_PROVIDER ==
                                'elDokan' ||
                            environmentVariables?.LOYALTY_PROVIDER == 'sadhan'
                        "
                    class="wallet-container mat-menu-item show-menu-icons-in-drop-down hide-menu-icons-in-drop-down"
                >
                    <app-stars-list-menu
                        [lang]="lang"
                      
                    >
                    </app-stars-list-menu>
                    <span class="icon-text">{{
                        "button.myPointes" | translate
                    }}</span>
                </div>

                <div
                    *ngIf="environmentVariables?.ENABLE_USER_WALLET"
                    (click)="wallet()"
                    class="wallet-container mat-menu-item show-menu-icons-in-drop-down hide-menu-icons-in-drop-down"
                >
                    <app-wallet-list-menu></app-wallet-list-menu>
                    <span class="icon-text">{{
                        "button.myWallet" | translate
                    }}</span>
                </div>

                <button (click)="logOut()" mat-menu-item class="log-out-btn">
                    <mat-icon class="material-icons mr-1 position-icon-1"
                        >power_settings_new</mat-icon
                    ><span class="menu-icons">
                        {{ "header.dropdown.logout" | translate }}</span
                    >
                </button>
            </div>
        </mat-menu>

        <div
            #menuTrigger="matMenuTrigger"
            (mouseenter)="toggleMenu($event, true)"
            (mouseleave)="toggleMenu($event, false)"
            [matMenuTriggerFor]="loginUser"
            [routerLink]="['/' + lang + '/account/profile']"
            class="user-name d-flex align-items-center"
            id="userName"
        >
            <button
                #menuTrigger="matMenuTrigger"
                (mouseenter)="toggleMenu($event, true)"
                *ngIf="!userData?.is_guest"
                [matMenuTriggerFor]="loginUser"
                [routerLink]="['/' + lang + '/account/profile']"
                class="header-icon"
                mat-mini-fab
                [ngStyle]="{ 'margin-left': lang === 'ar' ? '0.5rem' : '0rem' }"
                [ngClass]="{
                    'white-outline':
                        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ===
                        false,
                    'icons-background':
                        environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                        environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
                    'defult-background-icons':
                        !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
                }"
            >
                <mat-icon
                (mouseover)="changeIconFill=false"
                (mouseleave)="changeIconFill=true" 
                    class="material-icons notranslate position-icon-1 defulat-icons-color"
                    [ngClass]="{
                        'material-symbols-outlined':
                            (environmentVariables?.ENABLE_HEADER_ICONS_FILL ===
                            false && changeIconFill),
                        'icons-fill-color':
                            environmentVariables?.HEADER_ICONS_FILL_COLOR 
                    }"
                    >person</mat-icon
                >
            </button>
            <span
                [ngClass]="{
                    'd-none-mob': environmentVariables?.ENABLE_MENU_BUTTON
                }"
            >
                {{ userData?.name }}
            </span>

            <mat-icon
                [ngClass]="{
                    'd-none-mob': environmentVariables?.ENABLE_MENU_BUTTON
                }"
                [matMenuTriggerFor]="loginUser"
                class="material-icons profileArrow"
                >arrow_drop_down</mat-icon
            >
        </div>
    </ng-container>

    <!-- Mobile Menu Items -->
    <div class="d-md-none d-flex mobile-show">
        <div
            class="our-stores-container d-flex align-items-center mr-2"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON"
            [routerLink]="
                (environmentVariables?.MENU_BUTTON_LINK.includes('/en') ||
                environmentVariables?.MENU_BUTTON_LINK.includes('/ar')
                    ? ''
                    : '/' + lang + '/') + environmentVariables?.MENU_BUTTON_LINK
            "
        >
            <img  loading="lazy" 
                [src]="environmentVariables?.MENU_BUTTON_IMAGE"
                alt="Menu"
            />

            <span class="mx-1 hide-our-store d-md-block d-none">
                {{
                    lang == "en"
                        ? environmentVariables?.MENU_BUTTON_TEXT
                        : environmentVariables?.MENU_BUTTON_TEXT_AR
                }}
            </span>
        </div>

        <!-- Menu Items 2 -->
        <div
            class="our-stores-container d-flex align-items-center mr-2"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_2 === true"
            [routerLink]="
                (environmentVariables?.MENU_BUTTON_LINK_2.includes('/en') ||
                environmentVariables?.MENU_BUTTON_LINK_2.includes('/ar')
                    ? ''
                    : '/' + lang + '/') + environmentVariables?.MENU_BUTTON_LINK_2
            "
        >
            <img  loading="lazy"
                [src]="environmentVariables?.MENU_BUTTON_IMAGE_2"
                alt="Menu"
            />

            <span class="mx-1 hide-our-store d-md-block d-none">
                {{
                    lang == "en"
                        ? environmentVariables?.MENU_BUTTON_TEXT_2
                        : environmentVariables?.MENU_BUTTON_TEXT_AR_2
                }}
            </span>
        </div>

        <!-- Menu Items 3 -->
        <div
            class="our-stores-container d-flex align-items-center mr-2"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_3 === true"
            [routerLink]="
                (environmentVariables?.MENU_BUTTON_LINK_3.includes('/en') ||
                environmentVariables?.MENU_BUTTON_LINK_3.includes('/ar')
                    ? ''
                    : '/' + lang + '/') + environmentVariables?.MENU_BUTTON_LINK_3
            "
        >
            <img  loading="lazy"
                [src]="environmentVariables?.MENU_BUTTON_IMAGE_3"
                alt="Menu"
            />

            <span class="mx-1 hide-our-store d-md-block d-none">
                {{
                    lang == "en"
                        ? environmentVariables?.MENU_BUTTON_TEXT_3
                        : environmentVariables?.MENU_BUTTON_TEXT_AR_3
                }}
            </span>
        </div>

        <!-- Menu Items 4 -->
        <div
            class="our-stores-container d-flex align-items-center mr-2"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_4 === true"
            [routerLink]="
                (environmentVariables?.MENU_BUTTON_LINK_4.includes('/en') ||
                environmentVariables?.MENU_BUTTON_LINK_4.includes('/ar')
                    ? ''
                    : '/' + lang + '/') + environmentVariables?.MENU_BUTTON_LINK_4
            "
        >
            <img  loading="lazy"
                [src]="environmentVariables?.MENU_BUTTON_IMAGE_4"
                alt="Menu"
            />

            <span class="mx-1 hide-our-store d-md-block d-none">
                {{
                    lang == "en"
                        ? environmentVariables?.MENU_BUTTON_TEXT_4
                        : environmentVariables?.MENU_BUTTON_TEXT_AR_4
                }}
            </span>
        </div>
    </div>

    <!-- Menu Items 5 -->
    <div
        class="our-stores-container d-flex align-items-center mr-2"
        *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_5 === true"
        [routerLink]="
            (environmentVariables?.MENU_BUTTON_LINK_5.includes('/en') ||
            environmentVariables?.MENU_BUTTON_LINK_5.includes('/ar')
                ? ''
                : '/' + lang + '/') + environmentVariables?.MENU_BUTTON_LINK_5
        "
    >
        <img  loading="lazy"
            [src]="environmentVariables?.MENU_BUTTON_IMAGE_5"
            alt="Menu"
        />

        <span class="mx-1 hide-our-store d-md-block d-none">
            {{
                lang == "en"
                    ? environmentVariables?.MENU_BUTTON_TEXT_5
                    : environmentVariables?.MENU_BUTTON_TEXT_AR_5
            }}
        </span>
    </div>
</div>
